/**
 * @module Section-Advertisement
 */

import { Link } from "react-router-dom";
import { publicUrlFor } from "../../../globals/common-functions";
import AvertImage from "../../../globals/elements/avertimg";
/**
 * 
 * @returns Markup to show sample advertisement
 */
const SectionContactAdvert = () => {
    return (
        <div className="twm-advertisment  wow fadeInUp" data-wow-delay="0.4" data-wow-offset={200}  style={{ backgroundImage: `url(${publicUrlFor("images/add-bg.jpg")})` }}>
            <div className="overlay" />
            <div>
                {/* <h3 className="av-title">IT Solutions?</h3> */}
                <AvertImage src="images/Guildmac.svg" alt="" />
                {/* <h4 className="av-title2">Your Success Provide Best .</h4> */}
                <p className="pt-4">Have questions or need help? Our team is ready to assist you and provide support for any inquiries you may have.
                     {/* <p className="m-0">  <i className="feather feather-phone-call" />&nbsp;  </p> */}
                      <Link to={"mailto:info@guildmac.com"} className="d-block pt-3 text-white"><i className="feather feather-mail " /> &nbsp;info@guildmac.com </Link>
                </p>
         
            </div>
        </div>
    )
}

export default SectionContactAdvert;